var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({attrs:{"loading":_vm.buttonLoading || _vm.customButtonLoading},on:{"click":function($event){return _vm.buttonClicked()}}},'v-btn',_vm.$props,false),[_vm._v(_vm._s(_vm.label))])
}
var staticRenderFns = []

export { render, staticRenderFns }